import React from 'react';
import { useMobxStores } from '@stores/store';
import { isMobileWithOutIpad } from '@helpers/EnvHelper';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

/* 미디어 타입:이미지 */
const TopBanner = ({ banner }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type, imgUrl, youtubeUrl, title, thumbUrl } = banner;
  const { mediaStore, settingStore } = useMobxStores();
  const basic_title =
    "BTS (방탄소년단) 'Yet To Come (The Most Beautiful Moment)' Special MV @ BTS Island: In the SEOM";
  const basic_youtubeUrl = 'vnZZ-xjj7sk';
  const basic_thumb = '/img/media/maxresdefault.jpeg';

  if (!title) {
    banner.masterIdx = 1;
    banner.type = 'video';
    banner.title = basic_title;

    banner.thumbUrl = basic_thumb;
    banner.youtubeUrl = basic_youtubeUrl;
  }

  const detailClick = banner => {
    if (isMobileWithOutIpad()) {
      window.location.href = '?detail=' + banner.masterIdx;
    } else {
      let query = queryString.parse(location.search);
      query.detail = banner.masterIdx;
      navigate('?' + queryString.stringify(query));
      mediaStore.setDetailData(banner);
      settingStore.setMediaDialogState(true);
    }
  };

  return (
    <>
      <div onClick={() => detailClick(banner)} className="z-20 relative">
        <div className="cursor-pointer relative overflow-hidden ">
          <div className="relative w-full h-[0] pb-[56.26%] overflow-hidden">
            <img
              src={thumbUrl ? thumbUrl : basic_thumb}
              alt=""
              className="rounded-[1px] absolute top-0 left-0 w-full h-full bg-[#eee]"
            />
            {banner.type == 'video' && (
              <div className="bg-[#000] bg-opacity-60 w-full h-full absolute top-0 left-0 z-10 ">
                <div className="flex justify-center items-center m-auto h-full">
                  <span>
                    <svg
                      className="w-[50px] h-[50px] md:w-[70px] md:h-[70px] xl:w-[80px] xl:h-[80px]"
                      xmlns="http://www.w3.org/2000/svg"
                      width="77"
                      height="77"
                      fill="#fff"
                      viewBox="0 0 24 24"
                    >
                      <path d="M3 22v-20l18 10-18 10z" />
                    </svg>
                  </span>
                </div>
              </div>
            )}
          </div>
          <p
            className={
              'font-semibold font-TmoneyRoundWind text-[15px] xs:text-[13px] md:text-[18px] xl:text-[20px] text-ellipsis line-clamp-2'
            }
          >
            {title ? title : basic_title}
          </p>
        </div>
      </div>
    </>
  );
};
export default TopBanner;
